export default {
  name: 'calmante-perro-chihuahua',
  label: 'calmante para perro chihuahua',
  notes: [
    'por la proporción de la naranja el sándalo se convierte en fijador.',
  ],
  formula: [
    {
      name: 'aceite esencial de sándalo',
      quantity: 7.5,
      unit: 'ml',
      ref: 'sandalo'
    },
    {
      name: 'aceite esencial de bergamota',
      quantity: 3.75,
      unit: 'ml',
      ref: 'bergamota'
    },
    {
      name: 'aceite esencial de lavanda',
      quantity: 5,
      unit: 'ml',
      ref: 'lavanda'
    },
    {
      name: 'aceite esencial de ylang ylang',
      quantity: 1.25,
      unit: 'ml',
      ref: 'ylang-ylang'
    },
    {
      name: 'aceite esencial de naranja',
      quantity: 5,
      unit: 'ml',
      ref: 'lavanda'
    },
  ]
}
